import { createSelector } from '@reduxjs/toolkit';

const initialState = {
  timezone: 'UTC',
};

export default function userContextReducer(state = initialState) {
  return state;
}

export const selectUserTimezone = createSelector(
  [(state) => state.userContext.timezone],
  (timezone) => timezone,
);
